import Vue from 'vue';
import VueRouter from 'vue-router';
import Form from './components/Form.vue';

Vue.use(VueRouter);

export default new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,

  routes: [
    {path: '*', name: 'name', component: Form},
  ],
});
